module.exports = __webpack_public_path__ + "static/media/15.101.240bbe90.webp";